import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton, Menu } from '@mui/material';
import React from 'react';
const SIconButtonMenu = ({ sx, onClick, children, size = 'medium', menuItems }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        onClick && onClick();
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (_jsxs(React.Fragment, { children: [_jsx(IconButton, { onClick: handleClick, size: size, sx: { ...sx }, "aria-controls": open ? 'account-menu' : undefined, "aria-haspopup": 'true', "aria-expanded": open ? 'true' : undefined, children: children }), _jsx(Menu, { anchorEl: anchorEl, id: 'account-menu', open: open, onClose: handleClose, onClick: handleClose, slotProps: {
                    paper: {
                        elevation: 0,
                        sx: {
                            borderRadius: 1.5,
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            mt: 1.5,
                            '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1
                            },
                            '&::before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 0,
                                right: 14,
                                width: 10,
                                height: 10,
                                bgcolor: 'background.paper',
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0
                            }
                        }
                    }
                }, transformOrigin: { horizontal: 'right', vertical: 'top' }, anchorOrigin: { horizontal: 'right', vertical: 'bottom' }, children: menuItems })] }));
};
export default SIconButtonMenu;
